<template>
  <div
    v-if="playerInvites && playerInvites.length > 0"
    class="availability-wrapper d-flex flex-column flex-sm-row"
  >
    <div class="availability-label">
      <v-icon :color="iconColor" small>{{ icon }}</v-icon>
      {{ label }}
    </div>
    <div class="d-flex flex-row flex-wrap">
      <div
        :key="playerInvite.id"
        class="player-invite-name"
        v-for="playerInvite in playerInvites"
      >
        <v-menu
          nudge-top="35"
          close-delay="400"
          :disabled="$route.name === 'FanCalendar'"
        >
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="availability-token"
              v-bind:style="{ backgroundColor: tokenColor }"
            >
              <span
                style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
              >
                {{ playerInvite.player.firstName }}
                {{ playerInvite.player.lastName }}
              </span>

              <v-icon
                v-if="playerInvite.note"
                style="font-size: 16px; margin-top: -1px; margin-left: 4px;"
                >mdi-comment-outline</v-icon
              >
              <v-progress-circular
                v-if="updatingId === playerInvite.id"
                class="ml-2"
                color="rgba(0,0,0,.5)"
                indeterminate
                width="1"
                size="12"
              />
            </span>
          </template>
          <EventRowAvailabilityActionsModal
            :invite="playerInvite"
            @setPlayerAvailability="setPlayerAvailability"
            @removePlayer="removePlayer"
          />
        </v-menu>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from "@/plugins/i18n";
import { removePlayerFromEvent, updatePlayerAvailability } from "@/helpers/api";
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions } from "vuex";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";
import EventRowAvailabilityActionsModal from "./EventRowAvailabilityActionsModal.vue";

export default {
  name: "EventRowAvailability",
  components: { EventRowAvailabilityActionsModal },
  props: {
    playerInvites: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: {
      type: String
    },
    icon: {
      type: String,
      default: "mdi-dots-vertical"
    },
    iconColor: {
      type: String,
      default: "black"
    },
    tokenColor: {
      type: String,
      default: "black"
    }
  },
  data: () => ({
    updatingId: "",
    iconYes: "mdi-check-bold",
    iconNo: "mdi-cancel",
    iconUnknown: "mdi-help"
  }),
  methods: {
    setPlayerAvailability({ status, invite }) {
      if (invite.status.name !== status) {
        this.updatingId = invite.id;
        this.updateAvailability(status, invite)
          .then(() => {
            invite.status.name = status;
            this.updatingId = "";
          })
          .catch(err => {
            this.SHOW_SNACKBAR({
              text: i18n.tc("snackbar_message.save_failed"),
              timeout: 5000,
              color: "error"
            });
            this.updatingId = "";
          });
      }
    },
    async updateAvailability(inviteStatus, playerInvite) {
      const statuses = { Yes: "Accepted", No: "Declined", Unknown: "Pending" };
      return updatePlayerAvailability(
        playerInvite.id,
        statuses[inviteStatus],
        playerInvite.note
      );
    },
    async removePlayer({ invite }) {
      this.updatingId = invite.id;
      return removePlayerFromEvent(invite.id)
        .then(() => {
          this.$emit("removePlayerInvite", invite);
        })
        .finally(() => {
          this.updatingId = "";
        });
    },

    ...mapActions(ModuleTypes.SNACKBAR, {
      SHOW_SNACKBAR: SnackbarMutationTypes.SHOW_SNACKBAR
    })
  }
};
</script>
<style scoped>
.availability-wrapper {
}

.availability-label {
  font-size: 15px;
  font-weight: 500;
  min-width: 140px;
  display: inline-block;
  line-height: 25px;
}

.availability-label .v-icon {
  margin-top: -1px;
}

.availability-token {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  background-color: #ddd;
  padding: 5px 0 5px 10px;
  border-radius: 20px;
  margin-bottom: 5px;
  margin-right: 5px;
  width: 140px;
}

.availability-token:hover {
  opacity: 0.8;
}

.player-invite-tokens {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.player-invite-tokens .player-invite {
  white-space: nowrap;
  display: inline-block;
}

.player-invite-note {
  color: #666666;
  font-style: italic;
  font-size: 11px;
}

.availability-selectors {
  overflow: hidden !important;
}
</style>
